import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core'
import {HolyGrailGridModule} from '../../../../../craft/holy-grail-grid/holy-grail-grid.module'
import {TranslocoDirective, TranslocoService} from '@ngneat/transloco'
import {Level} from '../../../../../craft/holy-grail-grid/holy-grail-grid-sidenav/sidenav.types'
import {ArticlePreview, TopicListItem} from '../../../../../core/content/types/article.types'
import {PUBLIC_ROUTES} from '../../../../../shared/routing/public.routes'
import {LinkService} from '../../../../../core/i18n/link.service'

@Component({
  selector: 'bgo-article-page-sidenav',
  standalone: true,
  imports: [HolyGrailGridModule, TranslocoDirective],
  templateUrl: './article-page-sidenav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticlePageSidenavComponent implements OnInit {
  levels: Level[] = []

  @Input() topics: Pick<TopicListItem, 'breadcrumbTitle' | 'title' | 'path'>[] = []
  @Input() topic?: Pick<TopicListItem, 'breadcrumbTitle' | 'title' | 'path'>
  @Input() articles: Pick<ArticlePreview, 'title' | 'path'>[] = []

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly linkService: LinkService,
  ) {}

  ngOnInit(): void {
    if (!this.topic?.title || !this.topic.path) return

    this.levels = [
      {
        label: this.translocoService.translate('topic.allTopicsLabel'),
        path: this.linkService.localizedPathTo(PUBLIC_ROUTES.ARTICLE_OVERVIEW),
        items: this.topics.map(t => ({label: t.breadcrumbTitle || t.title, path: t.path})),
      },
      {
        label: this.topic?.breadcrumbTitle || this.topic?.title,
        path: this.topic.path,
        items: this.articles.map(a => ({label: a.title, path: a.path})),
      },
    ]
  }
}
